import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Link from 'next/link';
import { LocaleContext } from 'Components/hooks/context';

const atlas = new AtlasMetadataClient();

const RegionLink = ({ region: slug }) => {
  const locale = useContext(LocaleContext);
  const region = atlas.getRegion(slug);

  return locale === 'en' ? (
    <Link href='/regions/[region]' as={`/regions/${region.slug}`}>
      <a>{region.translations[locale]}
      </a>
    </Link>
  ) : (
    <Link href='/[locale]/regions/[region]' as={`/${locale}/regions/${region.slug}`}>
      <a>{region.translations[locale]}
      </a>
    </Link>
  );
};

export default RegionLink;
